<div class="tt-w-instant-answers">
  <tt-user-toolbar></tt-user-toolbar>
  <tt-ask v-model="questionText"
          :inAskMode="inAskMode" 
          :errorText="errorText"
          :countText="countText"></tt-ask>
  <tt-ask-results v-if="showResults"
                  :initialPageSize="iaConfig.initialPageSize"
                  :pageSize="iaConfig.pageSize"
                  :searchResults="searchResults"
                  :isSearching="isSearching"
                  :isOffline="isOffline"
                  @showError="onShowError"
                  :searchTerm="questionText"
                  @itemClick="onInstantAnswerClick">
    <div class="tt-c-instant-answers__submit-wrap">
      <span class="tt-c-instant-answers__results-prompt tt-u-hide-until--md" v-html="resultsPromptText"></span>
      <tt-button type="primary" class="tt-c-instant-answers__submit-question" @click="enterAskMode"><span v-html="$msg('ia.results.submitNew')"></span><tt-icon name="caret-right" size="sm"></tt-icon></tt-button>
    </div>
  </tt-ask-results>
  <tt-multi-items v-if="showMultiItems" :multiItems="multiItems" :promptText="multiItemsPromptText" :sku="globalStore.sku" @addItems="addMultiItems" @removeItem="removeMultiItem"></tt-multi-items>
  <div v-if="inAskMode" class="tt-c-instant-answers__action-buttons">
    <div v-show="isSubmitting" class="tt-o-spinner tt-o-spinner--submit"></div>
    <tt-button v-if="!isSubmitting" ref="submitBtn" type="primary" @click="submitQuestion" class="tt-c-instant-answers__submit" v-html="$msg('ia.submit')"></tt-button>
    <tt-button type="secondary" @click="cancelAskMode" class="tt-c-instant-answers__cancel" :disabled="isSubmitting" v-html="$msg('ia.cancel')"></tt-button>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/widgets/instant-answers/instant-answers.html